<template>
  <div class="oDetailApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">

    <dl v-if="orderNumber ==''">
      <dd v-for="(item,i) in b" @click="showTo(item.id)">
        <span>订单编号:{{item.number}}</span>
        <span>购买人:{{item.name}}</span>
        <span>销售价:￥{{item.price}}</span>
        <b>立即选择</b>
      </dd>
    </dl>

    <div v-if="orderNumber !=''">
    <div class="userInfo">
      <ul>
        <li>
          <span>昵称：</span>
          <font>{{set.username}}</font>
        </li>
        <li>
          <span>手机号：</span>
          <input v-if="set.phone==''" type="text"  v-model="phone" placeholder="请输入您的手机号">
          <font v-else>{{set.phone}}</font>
        </li>
        <li>
          <span>身份证号：</span>
          <input type="text" v-if="set.idCard==''" v-model="idCard" placeholder="请输入您的身份证号">
          <font v-else>{{set.idCard}}</font>
        </li>
      </ul>
    </div>

    <div class="scenic">
      <div class="top">
        <img class="left" :src="baseUrl+scenic.img" >
        <div class="right">
          <span class="curt">{{scenic.title}}</span>
          <span>{{scenic.level}}</span>
          <span>营业时间:{{scenic.business}}</span>
        </div>
      </div>
      <div class="bottom">剩余门票：{{total}}张可用</div>
    </div>

    <div class="orderInfo" v-if="order!=null">
      <div class="orderSn">订单编号：{{order.number}}</div>
      <div class="orderSn" style="color:#f00">状态：{{order.status == 2 ? '已支付' : '已完成'}}</div>
      <div class="orderSn">金额：￥{{order.price}}</div>
      <div class="orderSn">下单时间：{{order.paytime}}</div>
    </div>

    <button v-if="total>0" class="btn" @click="save">我要入园</button>
    </div>

    <el-dialog title="恭喜您！成功抵扣一张入园卷" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <div v-if="scenic.id != 10">
      <img id="avatar" :src="userData.avatar" />
      <div id="username">{{userData.username}}</div>
      <div id="username">入园时间：{{timer}}</div>
      <div id="username">已使用门票  {{yymb}}张</div>
      <div id="username">剩余门票 {{total}}张</div>
      <div class="gggg">抵扣入园卷成功，请您进园游览！</div>
      <div style="text-align:center;padding-bottom:45px;color:red">{{djstimer}}</div>
      </div>
      <div v-if="scenic.id == 10">
        <img :src="images" style="display:block;margin:0 auto" />
        <div id="username">请在闸机上刷码入园或用公园卡实名制身份证刷闸机入园</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        set:[],
        userData:[],
        scenic:[],
        total:0,
        order:[],
        baseUrl:'',
        phone:'',
        idCard:'',
        dialogFormVisible: false,
        timer:'',
        yymb:0,
        orderNumber:'',
        b:[],
        djstimer:0,
        images:''
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var id = this.$route.query.id;
          var url = encodeURIComponent('http://user.4008005216.com/main/oDetail?id='+id);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }else{
        this.userData = JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    mounted() {
      this.beforeMount();
      if(localStorage.getItem('userjwt') == null){
        this.login();
      }else{
        this.detail();
        this.timers();
        this.getBgg();
      }
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      save:function(){
        var that = this;
        if(that.phone == ''){
          alert('请输入手机号');
          return false;
        }
        if(that.idCard == ''){
          alert('请输入身份证号');
          return false;
        }
        that.fullscreenLoading = true;
        that.axios({
          'url': that.$host+'home/order/save',
          'method': 'post',
          params:{
            user_id:that.userData.id,
            phone:that.phone,
            idCard:that.idCard,
            order_id:that.order.id,
            card_id:that.order.card_id,
            num:1,
            s_id:that.scenic.id
          }
        }).then(function(response){
          that.fullscreenLoading = false;
          that.dialogFormVisible = true
          that.getScenic(that.orderNumber);
          var res = response.data.data
          that.timer = res.timer;
          that.images = 'data:image/jpeg/png;base64,'+res.img;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
      detail:function(e){
        //var id = this.$route.query.id;
        var that = this;
        this.axios({
          'url': that.$host+'home/user/index',
          'method': 'post',
          params:{
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data.data;
          that.set = res;
          that.phone = res.phone;
          that.idCard = res.idCard;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },
      showTo:function(id){
        this.orderNumber = id;
        this.getScenic(id)
      },

      getScenic:function(order_id){
        var id = this.$route.query.id;
        var that = this;
        that.axios({
          'url': that.$host+'home/order/useCard',
          'method': 'post',
          params:{
            user_id:that.userData.id,
            s_id:id,
            order_id:order_id
          }
        }).then(function(response){
          var res = response.data.data;

          that.scenic = res.scenic;
          that.total = res.total;
          that.yymb = res.yymb;
          that.order = res.order;

          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },

      getBgg:function(){
        var that = this;
        that.axios({
          'url': that.$host+'home/order/bbb',
          'method': 'post',
          params:{
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data.data;
          that.b = res

          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },

      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          that.userData = res.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
      timers:function(){
        var that = this;
        setInterval(function(){
            var date=new Date();
            var year=date.getFullYear();
            var month=date.getMonth()+1;
            var day=date.getDate();
            
            var hour=date.getHours();
            that.turnDate(hour);
            var min=date.getMinutes();
            that.turnDate(min);
            var sec=date.getSeconds();
            sec=that.turnDate(sec);
            that.djstimer=year+"年"+month+"月"+day+"日 "+hour+":"+min+":"+sec;
        },1000)
      },
      turnDate:function(date){
          if(date<10){
              return date="0"+date
          }else{
              return date
          }
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .el-dialog{
    width:80% !important;
  }
  .el-dialog__body{
    padding:20px 20px 0 20px !important;
  }
  .el-form-item__content{
    margin-left:0 !important
  }
  .el-form-item__label{
    text-align:left
  }
  .oDetailApp{
    max-width:640px;
    background:#f5f5f5;
    margin:0 auto;
    padding-top:10px;
  }
  .oDetailApp .userInfo{
    display:block;
    width:94%;
    background:#fff;
    margin:0 auto 10px auto;
    border-radius:5px;
  }
  .oDetailApp .userInfo ul{
    width:90%;
    display:block;
    margin:0 auto;
  }
  .oDetailApp .userInfo ul li{
    display:block;
    height:40px;
    border-bottom:solid 1px #ededed;
    padding:10px 0
  }
  .oDetailApp .userInfo ul li span{
    float:left;
    height:40px;
    line-height:40px;
    font-size:15px;
    letter-spacing:1px;
    color:#555;
    margin-left:5px
  }
  .oDetailApp .userInfo ul li font{
    float:right;
    height:40px;
    line-height:40px;
    font-size:15px;
    margin-right:10px
  }
  .oDetailApp .userInfo ul li input{
    float:right;
    height:40px;
    line-height:40px;
    font-size:15px;
    text-align:right;
    border:none;
    outline:none;
    font-size:15px;
  }

  .oDetailApp .scenic{
    display:block;
    width:94%;
    background:#fff;
    margin:0 auto 10px auto;
    border-radius:5px;
  }
  .oDetailApp .scenic .top:after{
    content: '';
    height: 0;
    line-height: 0;
    display: block;
    visibility: hidden;
    clear: both;
  }
  .oDetailApp .scenic .left{
    float:left;
    width:30%;
    border-radius:5px;
    margin:3% 0 0 3%
  }
  .oDetailApp .scenic .right{
    float:left;
    width:60%;
    margin:3% 0 0 2%
  }
  .oDetailApp .scenic .right span{
    display:block;
    font-size:14px;
    letter-spacing:1px;
    padding-bottom:10px;
    color:#333;
  }
  .oDetailApp .scenic .right span.curt{
    font-weight:bold;
    font-size:15px;
  }

  .oDetailApp .scenic .bottom{
    margin:3% 0 0 3%;
    font-weight:bold;
    color:#007aff;
    padding-bottom:3%;
    letter-spacing:1px;
  }

  .oDetailApp .orderInfo{
    display:block;
    width:94%;
    background:#fff;
    margin:0 auto 10px auto;
    border-radius:5px;
    height:150px
  }
  .oDetailApp .orderInfo .orderSn{
    padding:3% 0 0 3%;
    font-size:15px;
    letter-spacing:1px;
    font-weight:bold;
  }
  .oDetailApp .btn{
    display:block;
    width:84%;
    background:#007aff;
    margin:0 auto;
    border-radius:45px;
    height:45px;
    border:none;
    color:#fff;
    letter-spacing:1px;
    font-size:16px;
    font-weight:bold;
    margin-top:35px;
  }
  .gggg{
    color:red;;
    font-size:18px;
    padding-bottom:35px;
    text-align:center;
  }
  #avatar{
    border-radius:50%;
    width:80px;
    display:block;
    margin:0 auto
  }
  #username{
    text-align:center;
    font-size:18px;
    color:#000;
    padding:10px 0
  }

  .oDetailApp dd{
    width:92%;
    background:#fff;
    display:block;
    margin:0 auto;
    border-radius:5px;
    margin-bottom:10px;
    position:relative;
  }
  .oDetailApp dd span{
    display:block;
    padding:10px 20px;
    font-size:15px;
    letter-spacing:1px;
  }
  .oDetailApp dd b{
    position:absolute;
    right:15px;
    bottom:20px;
    color:#f00;
    font-size:15px;
  }
</style>